/**
 * Tipo del rappresentante (interno / esterno) quando la pagina non lo passa
 * alla shell dell'area associativa: lo si legge dal `representative_token` gia
 * in memoria (il backend lo firma con `tipo`, routes/auth.js e
 * routes/representativeArea.js), senza chiamate di rete.
 *
 * Serve solo a scegliere l'etichetta e la destinazione del pulsante in alto:
 * nessuna verifica della firma, nessun permesso deciso qui (l'accesso lo
 * decide sempre il backend). Token assente, illeggibile o senza un tipo
 * valido: `undefined`, cioe «tipo non noto» (comportamento di prima).
 */
export type TipoRappresentante = 'interno' | 'esterno';

const TIPI: readonly string[] = ['interno', 'esterno'];

/** Tipo dal payload di un JWT del rappresentante; `undefined` se non leggibile. Funzione pura. */
export const tipoDaToken = (token: string | null | undefined): TipoRappresentante | undefined => {
  if (!token) return undefined;
  try {
    const part = token.split('.')[1];
    if (!part) return undefined;
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4)));
    if (!payload || payload.type !== 'representative') return undefined;
    return TIPI.includes(payload.tipo) ? (payload.tipo as TipoRappresentante) : undefined;
  } catch {
    return undefined;
  }
};

/** Il tipo passato dalla pagina vince; altrimenti quello del token in memoria. */
export const tipoRappresentante = (tipo?: TipoRappresentante): TipoRappresentante | undefined => {
  if (tipo) return tipo;
  try {
    return tipoDaToken(localStorage.getItem('representative_token'));
  } catch {
    return undefined;
  }
};
